import { config } from 'config';
import { createCustomSlice } from 'core/utils';
import orderBy from 'lodash/orderBy';
const { sysAdmins } = config;

const initialState = {
    list: [],
    loading: false,
    registrationError: {},
    selected: {}
};

const userSlice = createCustomSlice({
    initialState,
    name: 'user',
    reducers: {
        setUserList (state, { payload }) {
            state.list = orderBy(parseUsers(payload), ['last_name', 'first_name'], ['asc', 'asc']);
        }
    },
    saga: [
        'createUser',
        'deleteUser',
        'getUser',
        'getUserList',
        'updateUser'
    ]
});

const parseUsers = list => list.filter(({ email }) => !sysAdmins.includes(email));

export const {
    createUser,
    deleteUser,
    getUser,
    getUserList,
    setUserList,
    setUserLoading,
    setUserRegistrationError,
    setUserSelected,
    updateUser
} = userSlice.actions;

export default userSlice.reducer;
